import React from 'react';
import Table from '../../components/common/Table';
import { PaymentDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/helpers/convertToUserTime';

interface PaymentTableProps {
  data: any[];
  handleEdit: (service: any) => void;
  handleDelete: (service: any) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const PaymentTable: React.FC<PaymentTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Status',
          key: 'paymentStatusName',
          render: (row) => {
            const status = row.paymentStatusName;
            let badgeColor = 'bg-gray-300 text-gray-800';

            if (status === 'Success')
              badgeColor = 'bg-green-100 text-green-800';
            else if (status === 'Failed')
              badgeColor = 'bg-red-100 text-red-800';
            else if (status === 'Pending')
              badgeColor = 'bg-yellow-100 text-yellow-800';

            return (
              <span
                className={`px-2 py-1 rounded text-xs font-medium ${badgeColor}`}
              >
                {status}
              </span>
            );
          },
        },
        {
          label: 'Member',
          key: 'memberName',
        },
        {
          label: 'Campaign',
          key: 'campaignName',
        },
        {
          label: 'Amount',
          key: 'amount',
          format: (value: any, row: any) =>
            row.amount ? `R${Number(row.amount).toFixed(2)}` : 'R0.00',
        },
        {
          label: 'Created',
          key: 'createdUtc',
          render: (row) => (
            <span>{convertToUserTime(row.createdUtc)}</span>
          ),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default PaymentTable;
